import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDay2026PrimaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

LaborDay2026PrimaryTwo.palette['--sui-palette-background-primary'] = '242 172 62';

export { LaborDay2026PrimaryTwo };